module.exports = __webpack_public_path__ + "img/ft-copyright.53a0dc18.svg";